import { useSnackbar as useDefaultSnackbar, OptionsObject } from 'notistack';
import Toast, { ToastSeverity } from '../components/General/Toast/Toast';
import React from 'react';

/**
 * Hook that allows to use custom snackbar
 */
export const useEnqueueSnackbar = () => {
    const { enqueueSnackbar } = useDefaultSnackbar();

    return (
        message: string,

        // extend the default options object
        options: OptionsObject & Partial<{ severity: ToastSeverity; additionalInfo: string }> = {
            severity: ToastSeverity.Info,
            autoHideDuration: 5000,
        },
    ) => {
        return enqueueSnackbar(message, {
            autoHideDuration: options.autoHideDuration,
            content: key => {
                // destructure the variant data from the extended options
                const { severity, additionalInfo } = options;
                return (
                    <Toast
                        id={key}
                        message={message}
                        severity={severity}
                        additionalInfo={additionalInfo}
                    />
                );
            },
        });
    };
};
